import Vue from 'vue'


import "core-js/stable";
import "regenerator-runtime/runtime";

import WiV from './WiV.vue'
import allResources from './allResources.vue'
import calendar from './calendar.vue'

import * as VueGoogleMaps from 'vue2-google-maps'

import * as ICAL from 'ical.js';


Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCh1QZGfEV848y0FOBzOnAUVPHKVXAZTvg',
    libraries: 'places,geocoding,geometry',
  },
  installComponents: true,
  autobindAllEvents: true,
  defaultZoom: 8,
  mapTypeControl: false,
  mapTypeControlOptions: { mapTypeIds: [] },

  defaultCenter: { lat: 48.429455, lng: -123.365445 },
});

// Check and initialize for #vue-element_Resources
if (document.querySelector('#vue-element_Resources')) {
  new Vue({
    el: '#vue-element_Resources',
    render: h => h(allResources)
  });
}

// Check and initialize for #vue-element
if (document.querySelector('#vue-element')) {
  new Vue({
    el: '#vue-element',
    render: h => h(WiV)
  });
}

// Check and initialize for #calendarVue
if (document.querySelector('#calendarVue')) {
  new Vue({
    el: '#calendarVue',
    render: h => h(calendar)
  });
}



// WEBPACK FOOTER //
// ./src/main.js